import {groupActionTypes} from "./actionTypes"

export function setGroupInfo(action, payload) {
    return {
        type: groupActionTypes[action],
        payload: payload
    }
}